import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Chip,
  Button,
} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Memberships = () => {
  return (
    <>
    <Helmet>
      <title>Memberships | Den Den Claw Ottawa Arcade</title>
      <meta
        name="description"
        content="Join a Den Den Claw membership for exclusive perks, discounts, and priority access at Ottawa's favourite claw machine arcade."
      />
      <link rel="canonical" href="https://www.dendenclaw.com/explore/memberships" />
    </Helmet>
    <Box sx={{ py: 6 }}>
      <Container maxWidth="md">
        {/* ---------- HEADER ---------- */}
        <Typography
          variant="h4"
          sx={{ fontWeight: 700, textAlign: "center", mb: 2 }}
        >
          Memberships 💙
        </Typography>

        <Typography
          variant="subtitle1"
          sx={{
            textAlign: "center",
            maxWidth: 700,
            mx: "auto",
            mb: 6,
            color: "text.secondary",
          }}
        >
          Becoming a Den Den Claw member is completely free — and it unlocks
          features that make playing more fun, rewarding, and competitive 🎮
        </Typography>

        {/* ---------- FREE CALLOUT ---------- */}
        <Card
          sx={{
            borderRadius: 3,
            boxShadow: 6,
            p: 4,
            mb: 6,
            textAlign: "center",
            background: "linear-gradient(180deg, #e8f2ff 0%, #f5faff 100%)",
          }}
        >
          <CardContent>
            <Chip
              label="FREE MEMBERSHIP ✨"
              color="primary"
              sx={{ mb: 2, fontWeight: 600 }}
            />

            <Typography sx={{ mb: 1 }}>
              Signing up is free and includes a Den Den Claw keychain to get you
              started.
            </Typography>

            <Typography sx={{ color: "text.secondary" }}>
              No subscriptions, no hidden fees — just more ways to enjoy the
              arcade.
            </Typography>
          </CardContent>
        </Card>

        {/* ---------- PERKS GRID ---------- */}
        <Grid container spacing={4} sx={{ mb: 8 }}>
          <Grid item xs={12} md={6}>
            <Card sx={{ borderRadius: 3, boxShadow: 6, p: 3 }}>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  Save & Accumulate Points ⭐
                </Typography>

                <Typography>
                  Members can save and accumulate points over time instead of
                  taking home a million stuffies. Save up for a big prize or
                  something special you really want.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ borderRadius: 3, boxShadow: 6, p: 3 }}>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  Leaderboards 📊
                </Typography>

                <Typography>
                  Track your points and see how you stack up against other
                  players on our leaderboard. Friendly competition encouraged!
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ borderRadius: 3, boxShadow: 6, p: 3 }}>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  Member Events & Tournaments 🏆
                </Typography>

                <Typography>
                  Entry to mini tournaments and special events requires a
                  membership. It’s how we keep things fair and fun for everyone.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ borderRadius: 3, boxShadow: 6, p: 3 }}>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  Keychain Access 🔑
                </Typography>

                <Typography>
                  Your membership keychain lets you scan in, track points, and
                  access member-only features throughout the arcade.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* ---------- BATTLEPASS FEATURE ---------- */}
        <Card
          sx={{
            borderRadius: 3,
            boxShadow: 6,
            p: 4,
            textAlign: "center",
            background: "linear-gradient(180deg, #e3f2fd 0%, #f0f8ff 100%)",
          }}
        >
          <CardContent>
            <Chip
              label="FEATURE HIGHLIGHT"
              color="secondary"
              sx={{ mb: 2, fontWeight: 600 }}
            />

            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
              Battle Pass 🎮
            </Typography>

            <Typography sx={{ mb: 2 }}>
              Members get access to our Battle Pass system.
              Complete weekly missions while you play to earn
              free rewards.
            </Typography>

            <Typography sx={{ mb: 2 }}>
              Rewards include Den Den trading cards, fob skins,
              and other exclusive goodies.
            </Typography>

            <Typography sx={{ color: "text.secondary" }}>
              No extra cost — just play, complete missions, and collect rewards.
            </Typography>
            <Grid container spacing={3} sx={{ mt: 2 }}>
            <Grid item xs={12} md={4}>
                <video
                src="/battlepass/1.mp4"
                autoPlay
                loop
                muted
                playsInline
                style={{ width: "100%", borderRadius: 12 }}
                />
                <Typography sx={{ mt: 1, fontWeight: 600 }}>
                Track Your Progress
                </Typography>
            </Grid>

            <Grid item xs={12} md={4}>
                <video
                src="/battlepass/2.mp4"
                autoPlay
                loop
                muted
                playsInline
                style={{ width: "100%", borderRadius: 12 }}
                />
                <Typography sx={{ mt: 1, fontWeight: 600 }}>
                Weekly Missions
                </Typography>
            </Grid>

            <Grid item xs={12} md={4}>
                <video
                src="/battlepass/3.mp4"
                autoPlay
                loop
                muted
                playsInline
                style={{ width: "100%", borderRadius: 12 }}
                />
                <Typography sx={{ mt: 1, fontWeight: 600 }}>
                Free Rewards
                </Typography>
            </Grid>
            </Grid>

          </CardContent>
        </Card>
        {/* ---------- VISIT US CTA ---------- */}
<Card
  sx={{
    borderRadius: 3,
    boxShadow: 6,
    p: 4,
    mt: 6,
    textAlign: "center",
    background: "linear-gradient(180deg, #e8f2ff 0%, #f5faff 100%)",
  }}
>
  <CardContent>
    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
      Ready to Become a Member?
    </Typography>

    <Typography sx={{ mb: 3, color: "text.secondary" }}>
      Sign up in-store, grab your keychain, and start earning points,
      rewards, and Battle Pass progress right away.
    </Typography>

    <Button
      variant="contained"
      size="large"
      component={Link}
      to="/contact"
      sx={{
        borderRadius: 999,
        px: 4,
        textTransform: "none",
        fontWeight: 600,
      }}
    >
      Visit Us
    </Button>
  </CardContent>
</Card>

      </Container>
    </Box>
    </>
  );
};

export default Memberships;
